import React, { useContext, useEffect, useState } from "react";
import { ApiData } from "../api";
import { IHowWork } from "../types";
import { showedNav, NavContext } from "../context/NavState";

const HowWorking = ({ title, number, text }) => (
  <div className="howWorkingBlock">
    <div className="howWorkingBlockTop">
      <div className="howWorkingBlockTitleText">{title}</div>
      <div className="howWorkingBlockTitleNumber">0{number}</div>
    </div>
    <div className="howWorkingBlockBot">{text}</div>
  </div>
);

const Pipeline = () => {
  const [howWorks, setHowWorks] = useState<IHowWork[]>([]);
  const { origNavigation, setNavigationContext } = useContext(NavContext);
  useEffect(() => {
    ApiData.howWorks().then((res) => {
      const howWorks = res.sort((a, b) => (a.sort > b.sort ? 1 : -1));
      if (!howWorks?.length) return;
      setHowWorks(howWorks);
      showedNav.add("pipeline");
      setNavigationContext(origNavigation.filter((el) => showedNav.has(el.to)));
    });
  }, []);

  const getHowWorking = (data: IHowWork[]) => {
    const arr = ["howWorkingTop", "howWorkingBottom"];
    const obj = [];
    let k = 0;
    data.forEach((el, i) => {
      if (!obj[k]?.length) obj.push([]);
      if (obj[k]?.length == 3) {
        k += 1;
        obj.push([]);
      }
      obj[k].push(
        <HowWorking
          key={i}
          number={i + 1}
          title={el.title}
          text={el.description}
        />,
      );
    });
    return obj.map((el, i) => (
      <div key={i} className={arr[i % 2]}>
        {el}
      </div>
    ));
  };
  return howWorks.length ? (
    <div className="blockContent">
      <div id="pipeline" className="blockHowWorking">
        <h3 className="titles">Как мы работаем</h3>
        <div className="howWorking">{getHowWorking(howWorks)}</div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default Pipeline;
